import React from 'react';
import { Button, Tooltip, TooltipTrigger } from 'react-aria-components';

type TooltipIconTriggerProps = Readonly<{
  onPress: () => void;
  ariaLabel: string;
  tooltip: React.ReactNode;
  children: React.ReactNode; // usually an icon
  tooltipDelay?: number;
}>;

export default function TooltipIconTrigger(props: TooltipIconTriggerProps) {
  const { onPress, ariaLabel, tooltip, children, tooltipDelay = 0 } = props;

  return (
    <TooltipTrigger delay={tooltipDelay}>
      <Button onPress={onPress} aria-label={ariaLabel} className="tooltip-icon-trigger">
        {children}
      </Button>
      <Tooltip offset={8}>{tooltip}</Tooltip>
    </TooltipTrigger>
  );
}
